import Tab from "@mui/material/Tab";
import {colorCodeEditorPrimary, colorEasyRed, colorText} from "../App/theme";
import {getFilenameByKey, isNewFile} from "./CodeEditorUtils";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {convertHexToRgba} from "../App/utils";
import React from "react";
import {closeTab} from "./CodeEditorHelpers";
import {renderItem} from "./FilesEditor";

export const renderOpenedTabs = ({loadedFiles, setEditors, setLoadedFiles, diffs}) => loadedFiles.map((file, index) => {
    const icon = renderItem(file);
    let color = diffs?.[file.Key]?.length ? colorCodeEditorPrimary : (file.tabIsLoading ? 'grey' : undefined);
    if (isNewFile(file)) color = colorEasyRed;
    return (
        <Tab
            key={index}
            label={
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {icon}
                <span style={{marginTop: -2, color}}>
                    {getFilenameByKey(file.Key)}
                    {diffs?.[file.Key]?.length ? '*' : ''}
                </span>
                    <IconButton
                        size="small"
                        component={"span"}
                        onClick={(event) => {
                            event.stopPropagation();
                            closeTab({index, setLoadedFiles, setEditors, loadedFiles});
                        }}
                    >
                        <CloseIcon
                            style={{
                                fontSize: '1rem',
                                color: diffs?.[file.Key]?.length ? colorCodeEditorPrimary : undefined }}
                        />
                    </IconButton>
                </div>
            }
            style={{
                fontSize: '0.875rem',
                textTransform: 'none',
                backgroundColor: file.selected ? convertHexToRgba(colorText, 0.00) : 'inherit'
            }}
        />
    )
})